// Curator notes on a candidate or a company: internal, one row per note with
// its author and time (rule 8), never edited; only its author may delete it.
// Never shown to companies or candidates.
import { z } from 'zod';

export const CURATOR_NOTE_MAX = 5000;

export const curatorNoteInputSchema = z.object({
  body: z.string().trim().min(1).max(CURATOR_NOTE_MAX),
});

/** A match note: one for the candidate, one for the company (Q62). */
export const MATCH_NOTE_MAX = 2000;
